import { message } from 'antd';
import { SurveyModel } from 'pages/khaosat/models';
import { surveyStore } from 'stores/root_store';


export const surveyValidation = (callback: (data: SurveyModel) => void) => {
  if (surveyStore.data) {
    const formValidations = Object.entries(surveyStore.data).map(([id, form]) => {
      return new Promise((resolve, reject) => {
        form
          .validateFields()
          .then(() => resolve([id, form.getFieldsValue()]))
          .catch(() => reject([id, undefined]));
      });
    });

    Promise.all(formValidations).then((result) => {
      if (result && Array.isArray(result)) {
        const data = Object.fromEntries(result as [string, any][]) as SurveyModel;
        callback(data);
      }
    }).catch(() => {
      message.error('Vui lòng điền đủ thông tin!')
    });
  }
}